<template>
  <div class="row pad-top-1" v-if="my_question !== []">
    <div class="col-3" v-html="my_question.survey_monkey_question_text"/>
    <div class="col-4">
      {{ clean_choices }}
    </div>
    <div class="col-2">
      <input class="form-control questionlocalname" type="text" v-model="my_question.local_name" placeholder="Measure/Name" minlength="1" v-on:change="selectionMade()" required/>
    </div>
    <div class="col-1 clickable">
      <input type="checkbox" :id="checkbox1id" v-model="topic_to_boolean" v-on:change="selectionMade()">
      <label :for="checkbox1id">{{ topic_to_boolean ? 'Yes' : 'No' }}</label>
    </div>
    <div class="col-1 clickable">
      <input type="checkbox" :id="checkbox2id" v-model="score_to_boolean" v-on:change="selectionMade()">
      <label :for="checkbox2id">{{ score_to_boolean ? 'Yes' : 'No' }}</label>
    </div>
    <div class="col-1">
      <font-awesome-icon icon="check" v-if="my_question.has_comments > 0"></font-awesome-icon>
    </div>
     <!--{{ my_question }} -->
  </div>
</template>
<script>
export default {
  name: 'QuestionItem',
  props: [ 
    'question'
  ],
  data: function() {
    return {
      my_question: this.question,
      checkbox1id: 'checkbox1-' + this.question.survey_monkey_question_id,
      checkbox2id: 'checkbox2-' + this.question.survey_monkey_question_id
    }
  },
  computed: {
    clean_choices: function() {
      if(!this.my_question) {
        return ''
      }
      if(!this.my_question.choices_map) {
        return ''
      }
      // mangle the choices map into something we can display
      let result = []
      Object.keys(this.my_question.choices_map).map(key => {
        result.push(this.my_question.choices_map[key].text)
      })
      return result.join(', ')
    },
    /* score inverse getter and setter */
    score_to_boolean: {
      get: function() {
        return this.my_question.score_backwards > 0
      },
      set: function(newValue) {
        if(newValue) {
          this.my_question.score_backwards = 1
        } else {
          this.my_question.score_backwards = 0
        }
      }
    },
    /* --- topic getter and setter */
    topic_to_boolean: {
      get: function() {
        return this.my_question.dimension < 1
      },
      set: function(newValue) {
        if(newValue) {
          this.my_question.dimension = 0
        } else {
          this.my_question.dimension = 1
        }
      }
    }
  },
  methods: {
    selectionMade (e) {
      this.$emit('update:question', this.my_question)
    }
  }
}
</script>
<style>
/* this ensures uncompleted local name fields in the questions stand out */
input.questionlocalname:invalid {
  background-color: #FFFFE0
}
</style>

/* 

{
  "survey_monkey_question_text":"Area",
  "survey_monkey_question_id":"138469054",
  "local_name":null,
  "score_backwards":0,
  "dimension":1,
  "has_comments":0,
  "choices_map":{
    "990378443":{
      "quiz_options":{"score":0},
      "visible":true,
      "text":"Admin",
      "position":1,
      "id":"990378443"
      },
    "990378444":{
      "quiz_options":{"score":0},
      "visible":true,
      "text":"Ops",
      "position":2,
      "id":"990378444"
    },
    "990378445":{
      "quiz_options":{"score":0},
      "visible":true,
      "text":"Management",
      "position":3,
      "id":"990378445"}
    }
  }

*/



// WEBPACK FOOTER //
// src/components/QuestionItem.vue